import React from 'react';
import '../../styles/christmas.css';
import bellImage from '../../assets/images/bell.png';
import treeImage from '../../assets/images/tree.png';

/**
 * Floating Christmas decorations - bell at bottom left, tree at top left
 */
const FloatingTree = () => {
  return (
    <>
      {/* Bell at bottom left */}
      <div className="floating-christmas-bell" aria-hidden="true">
        <img 
          src={bellImage} 
          alt="Christmas Bell" 
          className="bell-image-float"
        />
      </div>
      
      {/* Tree at top left */}
      <div className="floating-christmas-tree" aria-hidden="true">
        <img 
          src={treeImage} 
          alt="Christmas Tree" 
          className="tree-image-float"
        />
      </div>
    </>
  );
};

export default FloatingTree;
